import { useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function AITab({ deal }) {
    const [emailType, setEmailType] = useState("teaser");
    const [recipient, setRecipient] = useState("");
    const [email, setEmail] = useState("");
    const [loadingEmail, setLoadingEmail] = useState(false);

    const [notes, setNotes] = useState("");
    const [summary, setSummary] = useState("");
    const [loadingSum, setLoadingSum] = useState(false);

    const genEmail = async () => {
        setLoadingEmail(true);
        try {
            const { data } = await api.post("/ai/draft-email", { deal_id: deal.id, email_type: emailType, recipient_name: recipient });
            setEmail(data.email);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Failed");
        } finally {
            setLoadingEmail(false);
        }
    };
    const summarise = async () => {
        setLoadingSum(true);
        try {
            const { data } = await api.post("/ai/summarise-notes", { notes });
            setSummary(data.summary);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Failed");
        } finally {
            setLoadingSum(false);
        }
    };

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 max-w-6xl">
            <div className="border border-border rounded-md bg-white p-6">
                <div className="flex items-center gap-2 mb-4">
                    <Sparkles className="w-4 h-4" />
                    <h3 className="font-display font-bold tracking-tight">AI Email Drafter</h3>
                </div>
                <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                        <Select value={emailType} onValueChange={setEmailType}>
                            <SelectTrigger><SelectValue /></SelectTrigger>
                            <SelectContent>
                                <SelectItem value="teaser">Teaser email</SelectItem>
                                <SelectItem value="follow_up">Follow-up</SelectItem>
                                <SelectItem value="outreach">Buyer outreach</SelectItem>
                            </SelectContent>
                        </Select>
                        <Input placeholder="Recipient name (optional)" value={recipient} onChange={(e) => setRecipient(e.target.value)} />
                    </div>
                    <Button onClick={genEmail} disabled={loadingEmail} className="w-full bg-foreground text-background hover:bg-neutral-800 hover:text-white" data-testid="generate-email-btn">
                        {loadingEmail ? "Drafting…" : "Generate email"}
                    </Button>
                    {email && (
                        <MarkdownOutput mono testid="email-output" className="mt-4">{email}</MarkdownOutput>
                    )}
                </div>
            </div>
            <div className="border border-border rounded-md bg-white p-6">
                <div className="flex items-center gap-2 mb-4">
                    <Sparkles className="w-4 h-4" />
                    <h3 className="font-display font-bold tracking-tight">AI Note Summariser</h3>
                </div>
                <div className="space-y-3">
                    <Textarea rows={6} placeholder="Paste messy meeting notes…" value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="summarise-input" />
                    <Button onClick={summarise} disabled={loadingSum || !notes.trim()} className="w-full bg-foreground text-background hover:bg-neutral-800 hover:text-white" data-testid="summarise-btn">
                        {loadingSum ? "Summarising…" : "Summarise"}
                    </Button>
                    {summary && (
                        <MarkdownOutput testid="summary-output" className="mt-4">{summary}</MarkdownOutput>
                    )}
                </div>
            </div>
        </div>
    );
}
